export enum TrackingEvent {
    PreferenceLevel = 'O2ODiscovery_PrefChange_Step1_level',
    PreferenceInterest = 'O2ODiscovery_PrefChange_Step2_interest',
    PreferenceJockey = 'O2ODiscovery_PrefChange_Step3_trainerjockeyhorse',
    PrefProfileLevel = 'O2ODiscovery_PrefProfile_Step1_level',
    PrefProfileInterest = 'O2ODiscovery_PrefProfile_Step2_interest',
    PrefProfileJockey = 'O2ODiscovery_PrefProfile_Step3_trainerjockeyhorse',
    SkipLevel = 'O2ODiscovery_PrefSkip_Step1_level',
    SkipInterest = 'O2ODiscovery_PrefSkip_Step2_interest',
    SkipJockey = 'O2ODiscovery_PrefSkip_Step3_trainerjockeyhorse',
    ArticleShare = 'O2O_Discovery_Article_Share',
    ArticleLike = 'O2O_Discovery_Article_Like',
    CallToAction = 'O2O_Discovery_Article_CTA',
    VideoPlay = 'O2O_Discovery_Video_Play',
    BetPickCTA = 'O2O_Discovery_KOL_BetPickCTA',
    AddToCalendarArticle = 'O2O_Discovery_Article_AddToCalendar',
    AddToCalendarCalendarIcon = 'O2O_Discovery_Calendar_AddToCalendar',
    BettingStrategyToggleOn = 'O2ODiscovery_BettingStrategyToggle_On',
    BettingStrategyToggleOff = 'O2ODiscovery_BettingStrategyToggle_Off',
    CollapseKOLprofile = 'O2O_Discovery_Leaderboard_CollapseKOLprofile',
    ExpandKOLprofile = 'O2O_Discovery_Leaderboard_ExpandKOLprofile',
    CollapseBettingStrategy = 'O2O_Discovery_KOLbetpick_CollapseBettingStrategy',
    ExpandBettingStrategy = 'O2O_Discovery_KOLbetpick_ExpandBettingStrategy',
    Open3in1 = 'o2oDiscoverPreview_Open3in1',
    Download3in1 = 'o2oDiscoverPreview_Download3in1',
}
